import React from 'react';
import Presupuesto from '../../components/presupuesto/Presupuesto';
import PresupuestoPdf from '../../components/presupuesto/PresupuestoPdf';
import Layout from '../../components/layout/Layout';

export const PresupuestoPage = () => {
    return (<Layout children={<Presupuesto />} /> )
}

export const PresupuestoPdfPage = () => {
    return (<Layout children={<PresupuestoPdf />} /> )
}
